import React from "react";
import VoiceAssistantCard from "../../components/PSTVue/Teacher/VoiceAssistantCard";
import AIAppsGrid from "../../components/PSTVue/Teacher/AIAppsGrid";
import Navbar from "../../components/PSTVue/Navbar2";
export default function Teacher() {
  return (
    <div>
      <Navbar/>
          <main className="bg-white min-h-screen ">
    
      <div className="max-w-7xl mx-auto p-6 sm:p-10">
     
        <VoiceAssistantCard />
        <AIAppsGrid />
      </div>

    </main>
    </div>

  );
}